import {pointerUtils} from '@wix/document-manager-core'
const pointerType = 'renderRealTimeConfigPointer'

const {getPointer} = pointerUtils

const createPointersMethods = () => {
    const getRenderRealtimeConfigItem = (item: string) => getPointer(item, pointerType)
    const getIsCompHiddenPointer = (compId: string, viewMode: string, innerElementPath?: string[]) =>
        getPointer(
            [
                'compsToHide',
                viewMode,
                compId,
                ...(innerElementPath ? ['innerElementPath', innerElementPath.toString()] : [])
            ].join('_'),
            pointerType
        )
    return {
        general: {
            getRenderRealtimeConfigItem,
            getIsCompHiddenPointer
        }
    }
}

export {createPointersMethods}
